<template>
  <div class="d-flex w-100">
      <!--房间类型-->
      <el-select  
          v-model="offer_info.type" 
          placeholder="请选择类型" 
          @input="onFieldChange"
          class="w-50"  
          :class="{ roomRed: isFieldError('type') }" v-if="!modify">
          <el-option
          v-for=" i in $GVAR.roomStyle"
          :key="i.id"
          :label="i.name"
          :value="i.id">
          </el-option>
      </el-select>
      <!--房间类型-->
      <el-select 
          :value="offer_info.offer_title"
          :class="{ roomRed: isFieldError('offer_title') }"
          @change="getId($event)"
          @blur="blurs($event)"
          filterable
          allow-create
          default-first-option
          placeholder="选择或输入房型"
          class="w-50 ml-2" v-if="modify">
          <template>
              <el-option
                  v-for="roomItem in StoreRoomList"
                  :key="roomItem.title"
                  :label="roomItem.title"
                  :value="`${roomItem.id},${roomItem.title},${roomItem.type}`"
              >
              </el-option>
          </template>
        </el-select>
        <!--早餐-->
        <el-select 
              v-model="offer_info.breakfast"
              :class="{ roomRed: isFieldError('breakfast') }"
              @change="changeBreakfastType($event)"
              @blur="blurBreakfastType($event)"
              filterable
              allow-create
              default-first-option
              placeholder="选择或输入早餐"
              class="w-50 ml-2" v-if="modify">
          <template >
              <el-option
                  v-for="roomItem in $GVAR.breakfastTypeArr"
                  :key="roomItem.name"
                  :label="roomItem.name"
                  :value="`${roomItem.id},${roomItem.name}`"
              >
              </el-option>
          </template>
        </el-select>
        <!--间数-->
        <el-input 
            type="number"  
            v-model.number="offer_info.room_num" 
            @mousewheel.native.prevent
            @input="onFieldChange" 
            class="ml-2 w-40" 
            :class="[
              { roomRed: isFieldError('room_num') },  
              modify?'':'w-50'
            ]"
            placeholder="间数" >
            <span slot="append">间</span>
        </el-input>
        <!--单价-->
        <el-input 
        placeholder="金额"
        v-model.number="offer_info.offer_price"  
        class=" ml-2 w-40"
        @input="onFieldChange"
        :class="{ roomRed: isFieldError('offer_price') }"
        type="number" v-if="modify">
            <!-- <span slot="prepend">&yen;</span> -->
            <span slot="append" class="lisxn">元/晚</span>
        </el-input>
  </div>
</template>

<script>
import { mapState} from 'vuex'
export default {
  name: '',
  components: {},
  props: {
      modify: {
          type: Boolean,
          default: false,
      },
      isSubmit: {
          type: Boolean,
          default: false,
      }
  },
  data() {
    return {
      offer_info:{ type:'',room_num:'',offer_price:'',offer_id:'',offer_title:'',breakfast:''},
    };
  },
  computed: {
      ...mapState(['StoreRoomList']),
  },
  watch: {
    offer_info: {
      handler(newVal) {
        this.$emit('batchSubmit',newVal);
      },
      deep: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 判断单个字段是否标红
    isFieldError(field) {
        if (!this.isSubmit) return false;
        const key = `${field}`;
        return !this.offer_info[key];
    },
    // 输入时实时更新错误状态
    onFieldChange() {
        if (!this.isSubmit) return;
        // this.validateAll();
    },
    //清空信息
    clearInfo(){
        this.offer_info={ type:'',room_num:'',offer_price:'',offer_id:'',offer_title:'',breakfast:''};
    },
    // 房型相关
    getId(val){
        let [id,name,type] = val.split(',');
        let room_offer={...this.offer_info,offer_id:id?id:'0',offer_title:name?name:id,type:`${type}`};
        this.offer_info=room_offer;
    },
    blurs(val){
        let StoreRoomList=this.StoreRoomList;
        let room_offer=StoreRoomList.find(item=>item.title==val.target.value);
        if(val.target.value&&!room_offer&&val.target.value!=this.offer_info.offer_title){
            let room_offer={...this.offer_info,offer_id:'0',offer_title:val.target.value}
            this.offer_info=room_offer;
        }
    },
    //早餐类型
    changeBreakfastType(val){
        let [id, name] = val.split(',');
        let room_offer={...this.offer_info,breakfast:name};
        this.offer_info=room_offer;
    },
    blurBreakfastType(val){
        if(val.target.value){
          let room_offer={...this.offer_info,breakfast:val.target.value};
          this.offer_info=room_offer;
        }
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
